export interface ListingGategoryGroupResponse {
    Id: number | null;
    Name: string | null;
    IconId: string | null;
    ImageId: string | null;
    Enabled: boolean | null;
    ListingCategories: ListingCategoryResponse[];
}

export interface ListingCategoryResponse {
    Id: number | null;
    Name: string | null;
    ImageId: string | null;
    GroupId: number | null;
    Enabled: boolean | null;
}

export class ListingCategoryGroup {
    Id: number | null;
    Name: string | null;
    IconId: string | null;
    ListingCategories: ListingCategory[];
    ImageId: string | null;
    Enabled: boolean = true;
    constructor(fromServer?: ListingGategoryGroupResponse) {
        if (fromServer != null) {
            this.Id = fromServer.Id || null;
            this.Name = fromServer.Name || null;
            this.IconId = fromServer.IconId || null;
            this.ImageId = fromServer.ImageId || null;
            this.Enabled = fromServer.Enabled;
            this.ListingCategories = fromServer.ListingCategories && fromServer.ListingCategories.length ? fromServer.ListingCategories.map(category => new ListingCategory(category)) : [];
        }
    }
}

export class ListingCategory {
    Id: number | null;
    Name: string | null;
    ImageId: string | null;
    Enabled: boolean = true;
    GroupId: number | null;
    constructor(fromServer?: ListingCategoryResponse) {
        if (fromServer != null) {
            this.Id = fromServer.Id || null;
            this.Name = fromServer.Name || null;
            this.ImageId = fromServer.ImageId || null;
            this.GroupId = fromServer.GroupId || null;
            this.Enabled = fromServer.Enabled;
        }
    }
}

export interface CourierServiceResponse {
    Id: number | null;
    Name: string | null;
    LogoId: string | null;
    Enabled: boolean | null;
    Description: string | null;
    PackageOptions: PackageOptionResponse[];
    Deleted: boolean;
}

export interface PackageOptionResponse {
    Id: number | null;
    Name: string | null;
    LengthCm: number | null;
    HeightCm: number | null;
    WidthCm: number | null;
    WeightKg: number | null;
    CourierServiceId: number | null;
    Price: number | null;
    Deleted: boolean;
}

export class CourierServiceModel {
    Id: number | null;
    Name: string | null;
    LogoId: string | null;
    Enabled: boolean | null;
    Description: string | null;
    PackageOptions: PackageOption[];
    Deleted: boolean;
    constructor(fromServer?: CourierServiceResponse) {
        if (fromServer != null) {
            this.Id = fromServer.Id || null;
            this.Name = fromServer.Name || null;
            this.LogoId = fromServer.LogoId || null;
            this.Enabled = fromServer.Enabled || null;
            this.Description = fromServer.Description || null;
            this.Deleted = fromServer.Deleted;
            this.PackageOptions = fromServer.PackageOptions ? fromServer.PackageOptions.map(option => new PackageOption(option)) : [];
        }
    }
}

export class PackageOption {
    Id: number | null;
    Name: string | null;
    LengthCm: number | null;
    HeightCm: number | null;
    WidthCm: number | null;
    WeightKg: number | null;
    CourierServiceId: number | null;
    Price: number | null;
    Deleted: boolean;

    constructor(fromServer?: PackageOptionResponse) {
        if (fromServer != null) {
            this.Id = fromServer.Id || null;
            this.Name = fromServer.Name || null;
            this.LengthCm = fromServer.LengthCm || null;
            this.HeightCm = fromServer.HeightCm || null;
            this.WidthCm = fromServer.WidthCm || null;
            this.WeightKg = fromServer.WeightKg || null;
            this.CourierServiceId = fromServer.CourierServiceId || null;
            this.Price = fromServer.Price || null;
            this.Deleted = fromServer.Deleted || false;
        }
    }
}

export enum ViewTypeEnum {
  Size = 1,
  Color = 2
}

export interface OptionValueResponse {
    Id: number;
    Name: string;
    Value: string;
    OptionId: number;
    IsCustom: boolean;
    Deleted: boolean;
}

export class OptionValue {
  id: number;
  name: string;
  value: string;
  optionId: number;
  isCustom: boolean;
  deleted: boolean = false;

  constructor(item: OptionValueResponse ) {
    if (item) {
        this.id = item.Id || 0;
        this.name = item.Name || '';
        this.value = item.Value || '';
        this.optionId = item.OptionId || 0;
        this.isCustom = item.IsCustom || false;
        this.deleted = item.Deleted || false;
    }
  }
}

export interface ListingOptionResponse {
    Id: number;
    Name: string;
    Description: string;
    Values: OptionValueResponse[];
    ViewType: ViewTypeEnum;
    Deleted: boolean;
}

export class ListingOption  {
  id: number;
  name: string;
  description: string;
  values: OptionValue[];
  viewType: ViewTypeEnum = ViewTypeEnum.Size;
  deleted: boolean = false; 

  constructor(item: ListingOptionResponse = null) {
    if (item) {
        this.id = item.Id || 0;
        this.name = item.Name || '';
        this.description = item.Description || '';
        this.viewType = item.ViewType || ViewTypeEnum.Size;
        this.values = item.Values.map(v => new OptionValue(v));
        this.deleted = item.Deleted || false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/models/inModels/MarketPlaceModel.ts